export const httpStatus = {
    setStatusCode: 'httpStatus/setStatusCode',
    setIsShow: 'httpStatus/setIsShow',
    setStatusData: 'httpStatus/setStatusData',
};

export const alertData = {
    setMsg: 'alertData/setMsg',
    setIsShow: 'alertData/setIsShow',
    setCallback: 'alertData/setCallback',
    setIsShowCancelBtn: 'alertData/setIsShowCancelBtn',
};
export const confirmData = {
    setMsg: 'confirmData/setMsg',
    setIsShow: 'confirmData/setIsShow',
    setCallback: 'confirmData/setCallback',
    setIsShowCancelBtn: 'confirmData/setIsShowCancelBtn',
    setSubmitBtnText: 'confirmData/setSubmitBtnText',
};

export const pageData = {
    setIsLoading: 'pageData/setIsLoading',
    setIsFirstEdit: 'pageData/setIsFirstEdit',
    setShowByKey: 'pageData/setShowByKey',
};

export const userData = {
    setCurrentPosition: 'userData/setCurrentPosition',
    setPositionErrorCode: 'userData/setPositionErrorCode',
    setSpotPosition: 'userData/setSpotPosition',
    setValidScopExtent: 'userData/setValidScopExtent',
};

export const dataList = {
    setAttractionList: 'dataList/setAttractionList',
    setEventList: 'dataList/setEventList',
    setRiverList: 'dataList/setRiverList',
    setNewsList: 'dataList/setNewsList',
    setNewsLoading: 'dataList/setNewsLoading',
    setDataLoading: 'dataList/setDataLoading',
    setMappings: 'dataList/setMappings',
    setQrcodesList: 'dataList/setQrcodesList',
};
